import React, { Component } from 'react'
import './Footer.css'

class Footer extends Component {
    render() {
        return (
            <footer className='footer'>
                
            </footer>
        )
    }
}

export default Footer